import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';
import { useOrganization } from '../../contexts/OrganizationContext';

/**
 * Persistent notice on demo workspace surfaces, so sample findings are never
 * mistaken for the user's own code. Rendered from SidebarLayout so it covers
 * every surface sharing the app chrome (overview, scans, findings, finding
 * detail). Deliberately not dismissible — the signal has to outlast the visit.
 */
const SampleDataBanner: React.FC = () => {
  const { currentOrganization } = useOrganization();

  if (!currentOrganization?.is_demo) {
    return null;
  }

  return (
    <div
      role="status"
      className="sticky top-0 z-20 bg-brand-primary/10 dark:bg-brand-primary/20 border-b border-brand-primary/30 px-4 py-2 shrink-0"
    >
      <div className="flex items-center justify-center gap-2 max-w-7xl mx-auto text-sm text-ui-text-secondary">
        <FlaskConical className="w-4 h-4 text-brand-primaryDark dark:text-brand-primaryDarkMode shrink-0" />
        <span>
          Demo data —{' '}
          <Link
            to="/onboarding/connect"
            className="font-medium text-brand-primaryDark dark:text-brand-primaryDarkMode underline hover:no-underline transition-colors"
          >
            connect your repo
          </Link>{' '}
          to see your own vulnerabilities.
        </span>
      </div>
    </div>
  );
};

export default SampleDataBanner;
